import type { VoiceCommandResult } from './voiceCommandClient';

const STORAGE_KEY = 'voicePendingContactConfirmation';

export interface PendingContactConfirmation {
  intent: string;
  entityKey: string;
  extractedName: string;
  suggestedContact: {
    id: number;
    company_name?: string | null;
    contact_name?: string | null;
  };
  pendingEntities?: Record<string, unknown>;
}

const AFFIRMATIVE = /^(yes|yeah|yep|yup|correct|right|sure|ok|okay|confirm|confirmed|go ahead|do it)$/i;
const NEGATIVE = /^(no|nope|nah|wrong|incorrect|not that|different)$/i;

export function isAffirmativeReply(text: string): boolean {
  return AFFIRMATIVE.test(text.trim());
}

export function isNegativeReply(text: string): boolean {
  return NEGATIVE.test(text.trim());
}

export function storePendingContactConfirmation(result: VoiceCommandResult): void {
  if (result.phase !== 'contact_confirmation' || !result.data?.suggested_contact) return;

  const pending: PendingContactConfirmation = {
    intent: result.data.intent || 'create_quote',
    entityKey: result.data.entity_key || 'customer_name',
    extractedName: result.data.extracted_name || '',
    suggestedContact: result.data.suggested_contact,
    pendingEntities: result.data.pending_entities,
  };

  localStorage.setItem(STORAGE_KEY, JSON.stringify(pending));
}

export function getPendingContactConfirmation(): PendingContactConfirmation | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as PendingContactConfirmation;
  } catch {
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function clearPendingContactConfirmation(): void {
  localStorage.removeItem(STORAGE_KEY);
}
